import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/actionCreators';
import Helper from '../helpers/util';
import getFeatureDataKey from '../modules/getFeatureDataKey';
import styles from '../styles.json';
import definePopupClass from 'popup';

//const countryPositions = '/js/data/countries-v1.geojson';

let Popup;

class TravelMap extends React.Component {
	constructor() {
		super();

		this.saveRef = this.saveRef.bind(this);

		this.state = {
			mapAPILoaded: false,
			geoJSONLoaded: false,
			geoJSON: [],
		};
	}

	saveRef(ref) {
		this.containerNode = ref;
	}

	componentWillMount() {
		if (window.google && window.google.maps) {
			this.mapsLoaded();
		} else {
			Helper.pubsub.subscribe('googleMapsLoaded', () => {
				this.mapsLoaded();
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.mapAPILoaded) {
			this.eventListener(nextProps);
		}
		this.loadMapPosition(nextProps);
	}

	componentDidUpdate() {
		if (this.map) {
			window.google.maps.event.trigger(this.map, 'resize');
		}
	}

	loadMapPosition(props) {
		// load other maps position and zoom
		if (this.map && props.active !== this.props.active) {
			// map changed active state
			if (props.active && this.props.prevalenceMap) {
				// map became active and there is an existing position
				setTimeout(() => {
					this.map.setCenter(this.props.prevalenceMap.center);
					this.map.setZoom(this.props.prevalenceMap.zoom);
				}, 0);
			}
		}
	}

	// When new props are received, listen and updated GMAPS
	eventListener(nextProps) {
		if (!this.state.geoJSONLoaded) {
			return;
		}

		const path = nextProps.routing.location.pathname;

		if (path === '/travel') {
			this.showAllCountries();
			this.showCountryNames();
		} else if (path === '/outbreak') {
			this.hideAllCountries();
			this.hideCountryNames();
		} else {
			this.showSingleCountry(path);
		}

		this.featuredMouseEnter(nextProps);
	}

	mapsLoaded() {
		Popup = definePopupClass(Popup);
		this.setState({ mapAPILoaded: true }, () => {
			this.init();
		});
	}

	filterGeoJSON(data) {
		const dataFiltered = { ...data };

		// only return county polygons which we have travel data for
		const features = data.features.filter((i) => {
			if (typeof i.properties.STATE_CODE === 'undefined') {
				let countryWithData;
				for (let country of this.props.travel) {
					if (country.ISO === i.properties.iso_a2) {
						countryWithData = country;
					}
				}
				return countryWithData;
			}
			//return typeof i.properties.STATE_CODE === 'undefined';
		});
		dataFiltered.features = features;
		return dataFiltered;
	}

	init() {
		if (this.state.mapAPILoaded && this.props.isLoading === false) {
			// Enable MAP on element
			this.map = new window.google.maps.Map(this.containerNode, {
				zoom: 3.3,
				center: { lat: 22.35111, lng: 78.66774 },
				gestureHandling: 'greedy',
				styles: styles.withCountryName,
				//disableDefaultUI: true,
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
				minZoom: 3,
				restriction: {
					latLngBounds: {
						north: (Math.atan(Math.sinh(Math.PI)) * 180) / Math.PI,
						south: -((Math.atan(Math.sinh(Math.PI)) * 180) / Math.PI),
						west: -180,
						east: 180,
					},
					strictBounds: true,
				},
			});

			// save latest map position after movment
			window.google.maps.event.addListener(this.map, 'idle', () => {
				if (this.props.active) {
					this.props.saveTravelMap(this.map.getCenter(), this.map.getZoom());
				}
			});

			// Set initial style invisible
			this.map.data.setStyle({
				strokeOpacity: 0,
				fillOpacity: 0,
			});

			const geoJSON = [];
			this.map.data.addListener('addfeature', (event) => {
				if (!this.featureKey) {
					// no feature data key found already so find key that has iso data
					this.featureKey = getFeatureDataKey(event.feature);
				}

				geoJSON.push(event.feature);
				const country = this.props.travel.find((i) => i.ISO === event.feature[this.featureKey].iso_a2);
				if (country) {
					const colours = {
						4: '#FF7777',
						3: '#FFA15E',
						2: '#FFD685',
						1: '#61E6AC',
						0: '#b3b3b3',
					};
					const colour = colours[country.level || 0];
					this.map.data.overrideStyle(event.feature, {
						fillColor: colour,
						strokeWeight: 2,
						strokeColor: colour,
					});
				}
			});

			const countryGeoJSON = this.filterGeoJSON(this.props.geoJSON);
			this.map.data.addGeoJson(countryGeoJSON);

			window.google.maps.event.addListenerOnce(this.map, 'projection_changed', () => {
				this.setState({ geoJSONLoaded: true, geoJSON }, () => {
					this.eventListener(this.props);
				});
			});

			// Events
			this.map.data.addListener('mouseover', (event) => {
				if (
					'ontouchstart' in document.documentElement === false &&
					this.props.routing.location.pathname.indexOf('/travel') > -1 &&
					event.feature[this.featureKey].iso_a2.toLowerCase() !== this.getCountryParam()
				) {
					this.map.data.overrideStyle(event.feature, {
						fillOpacity: 0.52,
					});
				}
			});

			this.map.data.addListener('mouseout', (event) => {
				if (this.props.routing.location.pathname === '/travel') {
					this.map.data.overrideStyle(event.feature, {
						fillOpacity: 0.3,
					});
				} else if (
					this.props.routing.location.pathname.indexOf('/travel') > -1 &&
					event.feature[this.featureKey].iso_a2.toLowerCase() !== this.getCountryParam()
				) {
					this.map.data.overrideStyle(event.feature, {
						fillOpacity: 0,
					});
				}
			});

			this.map.data.addListener('click', (event) => {
				if (this.props.routing.location.pathname.indexOf('/travel') > -1) {
					this.props.history.push(`/travel/${event.feature[this.featureKey].iso_a2.toLowerCase()}`);
				}
			});

			this.map.addListener('click', () => {
				this.props.history.push('/travel');
			});
		}
	}

	featuredMouseEnter(nextProps) {
		const country = nextProps.featured;
		const path = nextProps.routing.location.pathname;
		const isFeaturedEmpty = Object.keys(country).length === 0 ? true : false;

		if (!isFeaturedEmpty && path === '/travel') {
			let countryFiltered = this.state.geoJSON.filter((i) => {
				return country.ISO.toUpperCase() === i[this.featureKey].iso_a2;
			});
			if (countryFiltered.length) {
				countryFiltered = countryFiltered[0];
				//this.panTo(countryFiltered);
				this.map.data.overrideStyle(countryFiltered, {
					fillOpacity: 0.52,
				});
			}
		}
	}

	panTo(country) {
		const latLng = new window.google.maps.LatLng(
			country[this.featureKey].center.lat,
			country[this.featureKey].center.lng
		);

		// if mobile offset country vertically
		if (window.innerWidth < 1200) {
			this.offsetCenterMap(
				latLng,
				0,
				window.innerHeight / 5 // vertical offset for mobiles
			);
		} else {
			this.map.setCenter(latLng);
		}
	}

	offsetCenterMap(latlng, offsetx, offsety) {
		const scale = Math.pow(2, this.map.getZoom());
		//console.log(this.map);
		//console.log(this.map.getProjection());
		const worldCoordinateCenter = this.map.getProjection().fromLatLngToPoint(latlng);
		const pixelOffset = new window.google.maps.Point(offsetx / scale || 0, offsety / scale || 0);
		const worldCoordinateNewCenter = new window.google.maps.Point(
			worldCoordinateCenter.x - pixelOffset.x,
			worldCoordinateCenter.y + pixelOffset.y
		);
		const newCenter = this.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
		this.map.setCenter(newCenter);
	}

	getCountryParam() {
		return this.props.routing.location.pathname.split('/travel')[1].split('/')[1];
	}

	showSingleCountry(path) {
		const pathArray = path.split('/');
		const iso2 = pathArray[pathArray.length - 1];
		let country = this.state.geoJSON.filter((i) => {
			return iso2.toUpperCase() === i[this.featureKey].iso_a2;
		});

		if (country.length) {
			country = country[0];
			this.panTo(country);
			this.hideAllCountriesExcept(iso2);
			this.map.data.overrideStyle(country, {
				fillOpacity: 0.5,
				strokeOpacity: 1,
			});
		}
	}

	hideAllCountriesExcept(iso2) {
		let countries = this.state.geoJSON.filter((i) => {
			return iso2.toUpperCase() !== i[this.featureKey].iso_a2;
		});

		countries.map((i) => {
			this.map.data.overrideStyle(i, {
				fillOpacity: 0,
				strokeOpacity: 0,
			});
		});
	}

	hideAllCountries() {
		this.state.geoJSON.map((i) => {
			this.map.data.overrideStyle(i, {
				fillOpacity: 0,
				strokeOpacity: 0,
			});
		});
	}

	showAllCountries() {
		this.state.geoJSON.map((i) => {
			this.map.data.overrideStyle(i, {
				fillOpacity: 0.3,
				strokeOpacity: 0,
			});
		});

		// Enable country names
		this.map.setOptions({
			styles: styles.withCountryName,
		});
	}

	showCountryNames() {
		this.map.setOptions({
			styles: styles.withCountryName,
		});
	}

	hideCountryNames() {
		this.map.setOptions({
			styles: styles.withoutCountryName,
		});
	}

	render() {
		return (
			<div className={`map-container ${this.props.className}`}>
				<div className="map" ref={this.saveRef} />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		travel: state.json.data.travel,
		outbreaks: state.json.data.outbreaks,
		geoJSON: state.json.geoJSON,
		isLoading: state.fetchDataLoading,
		routing: state.routing,
		featured: state.hoverFeatured,
		prevalenceMap: state.map.prevalenceMap,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		saveTravelMap: (center, zoom) => {
			dispatch({
				type: 'SAVE_TRAVEL_MAP',
				center: center,
				zoom: zoom,
			});
		},
		actionCreators,
		dispatch,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(TravelMap);
